import { forwardRef, InputHTMLAttributes } from "react";
import { useFormFieldState } from "../FormComponentHooks";
import styles from "./FormField.module.less";
import { extractValueProps, FormFieldProps } from "./FormFieldProps";

export type InputDateProps =
  & InputHTMLAttributes<HTMLInputElement>
  & FormFieldProps<string>;

const fallbackValue = new Date().toISOString().slice(0, 10);
export const InputDate = forwardRef<HTMLInputElement, InputDateProps>(
  function InputDate(props, ref) {
    const [valueProps, { ...inputProps }] = extractValueProps(props);
    const [value, setValue] = useFormFieldState(valueProps, fallbackValue);

    return (
      <input
        ref={ref}
        type="date"
        className={styles.input}
        {...inputProps}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    );
  },
);
